import React from "react";
import { faArrowUpRightFromSquare, faPlus, faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GenericModal, translate } from "@shape/reef-shared";
import { HelpDeskLink, HelpDeskOptions } from "./styled";

export const CREATE_TICKET_URL =
  "https://shapedigital.atlassian.net/servicedesk/customer/portal/35";

export const MY_TICKETS_URL =
  "https://shapedigital.atlassian.net/servicedesk/customer/user/requests?reporter=all&statuses=open";

interface RequestFormModalProps {
  modalIsOpen: boolean;
  setModalIsOpen: (isOpen: boolean) => void;
}

const RequestFormModal: React.FC<RequestFormModalProps> = ({
  modalIsOpen,
  setModalIsOpen,
}: RequestFormModalProps) => {
  const closeModal = () => setModalIsOpen(false);

  const renderLink = (
    href: string,
    icon: typeof faPlus,
    label: string,
    description: string,
    variant: "primary" | "secondary"
  ) => (
    <HelpDeskLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={closeModal}
      variant={variant}
      data-testid={`help-desk-${variant}`}
    >
      <FontAwesomeIcon className="option-icon" icon={icon} />
      <span className="option-text">
        <strong>{translate(label)}</strong>
        <small>{translate(description)}</small>
      </span>
      <FontAwesomeIcon
        className="external-icon"
        icon={faArrowUpRightFromSquare}
        title={translate("helpDeskModal.opensInNewTab")}
      />
    </HelpDeskLink>
  );

  return (
    <GenericModal
      isOpen={modalIsOpen}
      onClose={closeModal}
      width="600px"
      header={
        <div>
          <h2>{translate("helpDeskModal.title")}</h2>
          <h4>{translate("helpDeskModal.subtitle")}</h4>
        </div>
      }
      content={
        <HelpDeskOptions>
          {renderLink(
            CREATE_TICKET_URL,
            faPlus,
            "helpDeskModal.createTicket",
            "helpDeskModal.createTicketDescription",
            "primary"
          )}
          {renderLink(
            MY_TICKETS_URL,
            faTicket,
            "helpDeskModal.viewTickets",
            "helpDeskModal.viewTicketsDescription",
            "secondary"
          )}
        </HelpDeskOptions>
      }
    />
  );
};

export default RequestFormModal;
